




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {TipMotora} from "@/services/BackendProxies";
import dataProxyService from "@/services/data-proxy.service";

@Component({})
export default class TipoviMotoraEditor extends Vue {
    tipoviMotora = [];
    @Prop() value !: string;

    model = '';

    events = [];

    async created() {
        const tipoviMotora = await dataProxyService.vratiTipoveMotoraVozila();
        tipoviMotora.unshift(TipMotora.fromJS({id: '', naziv: '...'}));
        this.tipoviMotora = tipoviMotora.map(tmv => ({id: tmv.id, text: tmv.naziv}));
        this.model = this.value;
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Emit() input(val) {

    }
}
